module.exports = __webpack_public_path__ + "static/media/on-hold-lw.e171f1a4.png";